import { useTranslation } from 'react-i18next';
import classes from './Residential.module.scss';
import image from '../../../assets/img/Portfolio/residential.avif';

const Residential = () => {
    const { t } = useTranslation();
    return (
        <section className="container">
            <div className={classes.wrap}>
                <img className={classes.image} src={image} alt='' />
                <div className={classes.content}>
                    <h2 className={`${classes.title} font-48`}>
                        {t('portfolio.residential.title')}
                    </h2>
                    <h4 className={`${classes.subtitle} font-20`}>
                        {t('portfolio.residential.subtitle')}
                    </h4>
                    <div className={`${classes.text} txt-container font-16`}>
                        <p>{t('portfolio.residential.text_01')}</p>
                        <p>{t('portfolio.residential.text_02')}</p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Residential;